import { SimpleRouter } from './simple-routing';

export const onNotificationReceivedRouter = new SimpleRouter();
export const onNotificationClickedRouter = new SimpleRouter();
